export default __webpack_public_path__ + "static/media/superAdminButton.785a5c85.svg";